import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../components/Money';
import ShopMap from '../../reservation/components/ShopMap';

const ViewGiftCard = ({ shop, giftCard, gcBarber, brandId }) => (
  <div>
    <p className="u-mb+ u-mt" style={{ fontSize: '24px' }}>
      Thank you for your purchase of a gift card! We can’t wait to help make your gift a special experience.
    </p>
    <div className="c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up">
      Gift Card Details
    </div>
    <div className="c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up">
      Gift Card Details
    </div>
    <div className="layout layout--large u-mt+">
      <div className="layout__item u-1/2-medium-and-up">
        <dl>
          <dt className="c-heading c-heading--huge u-line-height-normal">Gift Card Code:</dt>
          <dd className="c-heading c-heading--huge u-line-height-normal u-mb u-type--bold">{giftCard.code}</dd>
          <dt className="c-heading c-heading--huge u-line-height-normal">Gift Card Amount:</dt>
          <dd className="c-heading c-heading--huge u-line-height-normal u-mb u-type--bold">
            <Money>
              {giftCard.outstandingBalance}
            </Money>
          </dd>
          <dt className="c-heading c-heading--huge u-line-height-normal">Professional:</dt>
          <dd className="c-heading c-heading--huge u-line-height-normal u-mb u-type--bold">
            {gcBarber.firstName} {gcBarber.lastName}
          </dd>
          { !brandId && <dt className="c-heading c-heading--huge u-line-height-normal">Shop:</dt> }
          { !brandId && <dd className="c-heading c-heading--huge u-line-height-normal u-type--bold">{shop.name}</dd> }
          { !brandId && (
            <dt className="c-heading c-heading--huge u-line-height-normal u-type--bold">{shop.address}</dt>
          ) }
          { !brandId && (
            <dd className="c-heading c-heading--huge u-line-height-normal u-type--bold u-mb+">{shop.zip}</dd>
          ) }
        </dl>
      </div>
      <div className="layout__item u-1/2-medium-and-up">
        {shop.location &&
          <div className="u-mb-">
            <ShopMap name={shop.name} address={shop.address} />
          </div>
        }
      </div>
    </div>
  </div>
);

ViewGiftCard.propTypes = {
  shop: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  giftCard: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  gcBarber: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  brandId: PropTypes.string.isRequired,
};

export default ViewGiftCard;



// WEBPACK FOOTER //
// ./src/app/giftCard/ViewGiftCard/ViewGiftCard.jsx